import React, { memo, useState, useEffect } from 'react';
import { useDispatch, useSelector } from 'react-redux';
import { toast } from 'react-toastify';
import { postAutomatedCtaUserAnalytics } from '../../../Store/actions/automatedCta.action';
import CtaSubscribeSpecialityV1 from './CtaSubscribeSpecialityV1';
import CtaSubscribeSpecialityV2 from './CtaSubscribeSpecialityV2';
let post_api_call_permission = true;
const CTASpeciality = ({ data, position }) => {
  let template_no = 0;
  useEffect(() => {
    template_no = Math.random() < 0.5;

    return () => {
      template_no = 0;
      post_api_call_permission = true;
    };
  }, []);

  const dispatch = useDispatch();
  const speciality_data = useSelector((state) => state.automatedCta.speciality_data);
  const [isSubscribed, setIsSubscribed] = useState(false);
  const ctaDisplayData = {
    ...data,
    speciality:
      speciality_data?.find((sp) => sp.master_specialities_id == data.speciality_id)
        ?.specialities_name ?? ''
  };
  const onSubscribe = (
    cta_id,
    cta_type_id,
    entity_id,
    entity_value,
    action,
    view_page_type,
    view_page_id
  ) => {
    if (post_api_call_permission) {
      post_api_call_permission = false;
      dispatch(
        postAutomatedCtaUserAnalytics(
          cta_id,
          cta_type_id,
          entity_id,
          entity_value,
          action,
          view_page_type,
          view_page_id,
          (res) => {
            post_api_call_permission = true;
            toast.success(
              'Thank you for your subscription. You will now get latest contents of the speciality'
            );
            setIsSubscribed(true);
          }
        )
      );
    }
  };
  switch (template_no) {
    case true:
      return (
        <CtaSubscribeSpecialityV1
          position={position}
          data={ctaDisplayData}
          onClickCallback={onSubscribe}
          isSubscribed={isSubscribed}
        />
      );
    case false:
      return (
        <CtaSubscribeSpecialityV2 
          position={position}
          data={ctaDisplayData}
          onClickCallback={onSubscribe}
          isSubscribed={isSubscribed}
        />
      );
    default:
      return (
        <CtaSubscribeSpecialityV1
          position={position}
          data={ctaDisplayData}
          onClickCallback={onSubscribe}
          isSubscribed={isSubscribed}
        />
      );
  }
};

export default memo(CTASpeciality);
